import { createRoot } from 'react-dom/client'
import { createElement } from 'react'
import './styles.css'
import App from './App'
import "@fontsource-variable/sixtyfour/full.css"

createRoot(document.getElementById('root')).render(createElement(App));
